export const errorBoundary = {
  Oops: "Oops",
  ApplicationErrorText: "Looks like we ran into an error.",
  ApplicationErrorMessage:
    "Please reload the page and try again. We've been notified of the issue and will work to resolve it.",
  BackToHome: "Back to home",
} as const;
